import React, { createContext, useContext, useEffect, useState } from 'react';
import { createHashRouter, RouterProvider, useInRouterContext } from 'react-router-dom';

const RouteContent = createContext(null);

function CurrentRouteContent() {
    return useContext(RouteContent);
}

// The singleton splat root retains every existing descendant Routes definition.
// Context updates the shell without rebuilding browser history or remounting forms.
export function NavigationRouter({ children }) {
    const withinRouter = useInRouterContext();
    const [router] = useState(() =>
        withinRouter ? null : createHashRouter([{ path: '*', element: <CurrentRouteContent /> }])
    );
    useEffect(() => () => router?.dispose(), [router]);
    if (withinRouter) return children;

    return (
        <RouteContent.Provider value={children}>
            <RouterProvider router={router} />
        </RouteContent.Provider>
    );
}
